var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { print } from '@0no-co/graphql.web';
import { ApiError } from './ApiError';
import { buildRequestInit, } from './buildRequestInit';
export function rawExecuteQuery(
/** The GraphQL query to execute */
query, 
/** Execution options, including API token and variables for query execution */
options) {
    return __awaiter(this, void 0, void 0, function () {
        var fetchFn, serializedQuery, response, parsedBody, _a, autoRetry, rateLimitReset, retryCount, waitTimeInSecs;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!query) {
                        throw new Error('Query is not valid');
                    }
                    fetchFn = options.fetchFn ||
                        (typeof fetch === 'undefined' ? undefined : fetch) ||
                        (typeof globalThis === 'undefined' ? undefined : globalThis.fetch);
                    if (typeof fetchFn === 'undefined') {
                        throw new Error('fetch() is not available: either polyfill it globally, or provide it as fetchFn option.');
                    }
                    serializedQuery = typeof query === 'string' ? query : print(query);
                    return [4 /*yield*/, fetchFn(options.graphqlEndpointUrl || 'https://graphql.datocms.com/', buildRequestInit(serializedQuery, options))];
                case 1:
                    response = _c.sent();
                    if (!((_b = response.headers
                        .get('content-type')) === null || _b === void 0 ? void 0 : _b.includes('application/json'))) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = (_c.sent());
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, response.text()];
                case 4:
                    _a = _c.sent();
                    _c.label = 5;
                case 5:
                    parsedBody = _a;
                    autoRetry = 'autoRetry' in options ? options.autoRetry : true;
                    if (!(response.status === 429 && autoRetry)) return [3 /*break*/, 7];
                    rateLimitReset = response.headers.get('X-RateLimit-Reset');
                    retryCount = (options.retryCount || 0) + 1;
                    waitTimeInSecs = rateLimitReset
                        ? Number.parseInt(rateLimitReset, 10)
                        : retryCount;
                    return [4 /*yield*/, wait(waitTimeInSecs * 1000)];
                case 6:
                    _c.sent();
                    return [2 /*return*/, rawExecuteQuery(serializedQuery, __assign(__assign({}, options), { retryCount: retryCount }))];
                case 7:
                    if (!response.ok ||
                        typeof parsedBody === 'string' ||
                        (typeof parsedBody === 'object' && 'errors' in parsedBody)) {
                        throw new ApiError({
                            status: response.status,
                            statusText: response.statusText,
                            headers: response.headers,
                            body: parsedBody,
                        }, serializedQuery, options);
                    }
                    return [2 /*return*/, [parsedBody.data, response]];
            }
        });
    });
}
export function executeQuery(
/** The GraphQL query to execute */
query, 
/** Execution options, including API token and variables for query execution */
options) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rawExecuteQuery(query, options)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result[0]];
            }
        });
    });
}
function wait(time) {
    return new Promise(function (resolve) {
        setTimeout(resolve, time);
    });
}
//# sourceMappingURL=executeQuery.js.map